import Notification, { NotificationType } from 'components/notifiers/Notification';
import strings from '../../../../../strings/strings.json';

export default function SavedSuccessfullyNotification() {
    return <Notification notificationType={NotificationType.SUCCESS} title={strings.general.saveSuccess} />;
}
